import { render, staticRenderFns } from "./RemarksList.vue?vue&type=template&id=19613b12"
import script from "./RemarksList.vue?vue&type=script&lang=js"
export * from "./RemarksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports